import { CrFilter } from '../types';

export function convertStarNumberToWord(numOfStars: string | undefined): CrFilter {
    switch (numOfStars) {
        case '1':
            return 'oneStar';
        case '2':
            return 'twoStar';
        case '3':
            return 'threeStar';
        case '4':
            return 'fourStar';
        case '5':
            return 'fiveStar';
        default:
            return 'all';
    }
}
